const SITE_URL = process.env.REACT_APP_SITE_URL;

export default function financialServiceSchema() {
  return {
    "@context": "https://schema.org",

    "@type": "FinancialService",

    "@id": `${SITE_URL}/#financialservice`,

    name: "Money Mart",

    url: SITE_URL,

    image: `${SITE_URL}/og-image.jpg`,

    description:
      "Money Mart is an independent Bank Channel Partner (DSA) helping customers compare and apply for Home Loans, Mortgage Loans, Business Loans, Construction Loans and other loan products from leading Banks and NBFCs. Money Mart does not lend money directly.",

    areaServed: {
      "@type": "Country",
      name: "India",
    },

    serviceType: [
      "Home Loan",
      "Business Loan",
      "Mortgage Loan",
      "Loan Against Property",
      "Construction Loan",
      "Personal Loan"
    ],

    provider: {
      "@id": `${SITE_URL}/#organization`
    }
  };
}